export default () => {
  const origin = useRequestURL().origin;

  return computed(() => {
    if (origin.includes("promopromo")) {
      return "promopromo";
    } else if (origin.includes("allefolders")) {
      return "allefolders";
    } else if (origin.includes("myshopi")) {
      return "myshopi";
    }

    // Fallback for localhost development
    return "myshopi";
  });
};
